import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';
import { useState } from 'react';

import { Capability, type Zeitraum } from '../../../../../../dtos';
import { type CalendarEvent } from '../../../../ResourceCalendar';
import { content } from './ActionButtons.content';
import { getSaveButtonState } from './ActionButtons.utils';

export type ActionButtonsProps = {
  readonly isOnlineThema: boolean;
  readonly ablauf: readonly Zeitraum[];
  readonly withResources: boolean;
  readonly selectedCalendarEvents: readonly CalendarEvent[];
  readonly onCancel: () => Promise<void>;
  readonly onSave: () => Promise<void>;
  readonly capabilities?: Capability[];
};

export const ActionButtons = ({
  selectedCalendarEvents,
  isOnlineThema,
  ablauf,
  withResources,
  onCancel,
  onSave,
  capabilities,
}: ActionButtonsProps) => {
  const [isSaving, setIsSaving] = useState(false);

  const { isSaveButtonDisabled, tooltip } = getSaveButtonState(
    isSaving,
    isOnlineThema,
    ablauf,
    withResources,
    selectedCalendarEvents,
    capabilities,
  );

  const handleSave = async (): Promise<void> => {
    setIsSaving(true);
    await onSave().finally(() => setIsSaving(false));
  };

  return (
    <Stack direction="row" spacing={2}>
      <Tooltip arrow placement="top" title={tooltip} data-testid="actionButtonsTooltip">
        <div>
          <Button size="small" variant="contained" disabled={isSaveButtonDisabled} onClick={handleSave}>
            {content.buttons.save}
          </Button>
        </div>
      </Tooltip>

      <IconButton size="small" sx={{ border: '1px solid lightgrey', borderRadius: '50%' }} onClick={onCancel}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};
